<template>
<!-- 活动抽奖 -->
<div class="hdcjbj">
  <el-row>
    <el-col :span="5">
      <div class="broadsidesz">
        <b>设置</b>
        <div>奖品名称　
          <el-input v-model="jpmc" size="mini" placeholder="请输入" maxlength="10"
          @blur="changeblur()" style="width: 16vh;"/>
        </div>
        <div>抽奖名额　
          <!-- <el-input v-model="cjme" size="mini" placeholder="请输入" maxlength="2" style="width: 16vh;"
          @blur="changeblur()" onkeyup="value=value.replace(/[^\d\.]/g,'').replace('.','')">
            <i slot="suffix" style="line-height: 26px;margin-right: 8px;">人</i>
          </el-input> -->
          <el-select v-model="cjme" placeholder="请选择" size="mini" style="width: 16vh;">
            <el-option v-for="item in cjmeoptions" :key="item.value" :label="item.label" :value="item.value"/>
          </el-select>
        </div>
      </div>
      
      <div class="cjjlzk" @click="toggleSidebar" v-show="isSidebarHidden">抽奖记录<i class="el-icon-arrow-right"/></div>
      <div class="broadsidecjjl" :class="{ hidden: isSidebarHidden }">
        <b>抽奖记录</b>
        <div style="height: 33vh;overflow-y: scroll;">
          <ul class="cjjlthree" v-for="(item, index) in cjjlArr" :key="index">
            <b>奖品名称：<span>{{item.prizename}}</span></b>
            <li>中奖人数：<span>{{item.winners.length}}人</span></li>
            <li>抽奖时间：<span>{{item.fist_lottery_time}}</span></li>
            <li>中奖号码：<span v-for="item in item.winners.join('、')" :key="item" style="display: inline-block;">{{item}}</span></li>
          </ul>
        </div>
        <div class="shouqiicon"><i class="el-icon-arrow-left cjjlsq" @click="toggleSidebar"/></div>
      </div>
    </el-col>
    <el-col :span="14">
    <div class="lotteryContainer">
    <div class="lotteryMain"
    v-loading="loading"
    element-loading-text="正在加载抽数据，请稍后..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.5)">
      <div class="lottery-tips">
        <span v-show="!jpmc">{{maxAwardTips}}</span><span v-show="jpmc">{{jpmc}}（{{rollLen}} / {{cjme}}人）</span>
      </div>
      <ul>
        <li class="lottery-item" v-for="(item, index) in smokeArr" :key="index">
          <div class="lottery-roll">
            <div class="rollItem"><img :src="item.usericon" style="margin-left: 30px;"></div>
            <div class="rollItem"><span>{{item.phone}}</span></div>
            <div class="rollItem"><span>{{item.playercode}}</span></div>
          </div>
        </li>
      </ul>
    </div>
    <div class="lotterybtn">
      <div class="btnfunc" v-show="hdcjState!=7">
        <button class="btnImg" @click="beginRoll" :disabled="prohibitrepetition"><img src="../assets/img/ks.png"/></button>
        <button class="btnImg" @click="stopRoll" :disabled="!prohibitrepetition"><img src="../assets/img/cq.png"/></button>
      </div>
    </div>
    </div>
    </el-col>
    <el-col :span="5">
    <div style="position: absolute;right: 0;">
      <div class="broadsidesz">
        <b>本轮抽奖</b>
        <template v-if="thissmoke.prizename">
          <ul style="margin: 10px 0 10px 30px;">
            <li>奖品名称：<span>{{thissmoke.prizename}}</span></li>
            <li>中奖人数：<span>{{thissmoke.winners.length}}人</span></li>
            <li>抽奖时间：<span>{{thissmoke.fist_lottery_time}}</span></li>
          </ul>
          <b>中奖号码</b>
          <ul style="margin: 10px 0 0 30px;">
            <li v-for="item in thissmoke.winners" :key="item">{{item}}</li>
          </ul>
        </template>
        <div v-else style="text-align: center;margin-bottom: 10px;"><b>暂无数据</b></div>
      </div>
      
      <div class="cjjlzk jccxbtn" @click="handlejccx" v-show="isjccxidden"><i class="el-icon-arrow-left"/>奖池查询</div>
      <div class="broadsidecjjl hiddenparts" :class="{ hidden: isjccxidden }">
        <b>奖池查询</b>
        <div style="margin: 10px 0 0 30px;">
          <el-input v-model="jccxinput" size="mini" placeholder="请输入订单号查询" maxlength="20" style="width:20vh;float: left;">
          <i slot="suffix" class="el-input__icon el-icon-search" @click="handler(1)" style="cursor: pointer;"></i>
          </el-input>
          <i class="el-icon-refresh-right" @click="handler(2)"
          style="margin: 2px 0 0 13px;font-size: 22px;cursor: pointer;"/>
        </div>
        <ul class="cjjlthree" style="height: 200px;overflow-y: scroll;">
          <li v-for="item in filPersons" :key="item">{{item.playercode}}</li>
        </ul>
        <div class="shouqiicon"><i class="el-icon-arrow-right cjjlsq jccxsq" @click="handlejccx"/></div>
      </div>
    </div>
    </el-col>
  </el-row>
</div>
</template>
<script>
import { getplayer, getwinners, postlottery } from "../api/shopWindow";
export default {
  name: 'eventlottery', // 活动抽奖
  data() {
    return {
      jpmc: '',
      cjme: 1,
      cjmeoptions: [{
        value: 1,
        label: '1'
      }, {
        value: 2,
        label: '2'
      }, {
        value: 3,
        label: '3'
      }, {
        value: 4,
        label: '4'
      }, {
        value: 5,
        label: '5'
      }],
      isSidebarHidden: true, // 侧边抽奖记录
      cjjlArr: [], // 抽奖记录集合
      thissmoke: {}, // 本轮抽奖
      isjccxidden: true,
      jccxinput: '', // 搜索框
      filPersons: [], // 接收watch的值
      
      maxAwardTips: '请输入奖品名称和抽奖名额', // 请输入奖品名称和抽奖名额
      rollLen: 0, // 本轮已抽中用户数
      
      // 闪烁集合
      flickerArr: [
        {
          "userid": 15092,
          "phone": "138****0739",
          "playercode": "434949",
          "usericon": require('../assets/img/bicon37.png')
        },
        {
          "userid": 15097,
          "phone": "151****6933",
          "playercode": "492695",
          "usericon": require('../assets/img/bicon37.png')
        },
        {
          "userid": 15096,
          "phone": "156****9125",
          "playercode": "390250",
          "usericon": require('../assets/img/bicon37.png')
        },
        {
          "userid": 15095,
          "phone": "151****5602",
          "playercode": "017845",
          "usericon": require('../assets/img/bicon37.png')
        },
        {
          "userid": 15092,
          "phone": "138****0739",
          "playercode": "842859",
          "usericon": require('../assets/img/bicon37.png')
        }
      ],
      smokeArr: [], // 抽中集合
      listId: '', // 列表id
      hdcjState: '', // 选中行状态 7
      zjArr: '', // 中奖集合
      extract: '', // 已抽取数量
      timer: '', // 定时器
      prohibitrepetition: false, // 禁止重复点击
      yyqtype:'', // 店铺活动 or 联盟活动
      loading: false,
    }
  },
  methods: {
    // 抽奖记录
    toggleSidebar() {
      this.isSidebarHidden = !this.isSidebarHidden;
    },
    // 奖池查询
    handlejccx() {
      this.isjccxidden = !this.isjccxidden;
    },
    // 抽奖集合
    getchoujiang(){
      this.loading = true;
      getplayer('',this.yyqtype,this.listId).then(data => {
        if (data.resultCode == 1) {
          this.loading = false;
          this.smokeArr = data.resultObj; // 先赋值大列表
          this.flickerArr = this.smokeArr; // 闪动数据赋值
        } else {
          this.smokeArr = [];
        }
      });
    },
    changeblur(){
      this.rollLen = 0;
    },
    // 开始
    beginRoll(){
      this.thissmoke = {
        prizename: '', // 奖品名称
        // winners: 0, // 中奖人数
        // fist_lottery_time: '', // 抽奖时间
        // winners: [], // 中奖号码 集合
      }
      if (this.jpmc == "") {
        this.$swal({
          text: "请输入奖品名称",
          type: "warning"
        });
        return false;
      }
      // if(this.cjme == ''){
      //   this.$swal({
      //     text: "请输入抽奖名额",
      //     type: "warning"
      //   });
      //   return false;
      // }
      if(this.cjme == this.rollLen){
        this.$confirm('当前奖品已完成抽奖，是否再次抽取一轮该奖品？', '温馨提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          this.prohibitrepetition = true;
          this.rollLen = 0;
          this.smokeArr=[];
          this.getzhongjiang(); // 中奖集合
          // this.$message({
          //   type: 'success',
          //   message: '操作成功!'
          // });
        }).catch(() => {
          this.prohibitrepetition = false;
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      }else{
        this.prohibitrepetition = true;
        this.rollLen = 0;
        this.smokeArr=[];
        this.getzhongjiang(); // 中奖集合
      }
    },
    // 中奖集合
    getzhongjiang(){
      let obj = {
        operatorid: localStorage.Id, // 操作人id
        lotterytype: this.yyqtype, // 抽奖类型 1=一元抢抽奖 2=店铺活动抽奖 3=联盟活动抽奖 默认1
        businessid: this.listId, // 业务主键ID，与抽奖类型配合使用 (如类型为幸运购抽奖，此字段为幸运购的活动ID)
        prizename: this.jpmc, // 奖品名称
        prizenum: Number(this.cjme), // 奖品总数
        count: 5, // 本轮最大中奖人数 不传则默认5
        isfilterwinner: 0, // 是否过滤中奖者0=否 1=过滤所有中奖者 2=过滤当前奖品
        remark: '', // 奖品备注 不传则默认空
      }
      postlottery(obj).then(data => {
        if (data.resultCode == 1) {
          this.zjArr = data.resultObj.winners; // 中奖集合
          this.extract = data.resultObj.prewinnernum; // 当前奖品已抽取数量
          this.smokeArr.length = this.cjme>5?5:this.cjme; // 赋值条数
          this.timer = setInterval(()=>{
            let n = Math.floor(Math.random() * (this.flickerArr.length - this.cjme))
            let m = n+Number(this.cjme)
            this.smokeArr = this.flickerArr.slice(n, m);
          }, 100)
        } else {
          // this.smokeArr = [];
          this.rollLen = 0;
          this.getchoujiang(); // 抽奖集合
          this.$swal({
            text: data.resultMsg,
            type: 'warning'
          })
        }
      });
    },
    // 抽取
    stopRoll(){
      clearInterval(this.timer);
      this.prohibitrepetition = false;
      // this.jpmc='';
      // this.cjme=1;
      this.smokeArr = this.zjArr;
      this.rollLen = this.extract;
      this.getcjjl(2); // 抽奖记录
    },
    // 抽奖记录
    getcjjl(type){
      getwinners('',this.yyqtype,this.listId).then(data => {
        if (data.resultCode == 1) {
          this.cjjlArr = data.resultObj;
          if(type==2){
            this.thissmoke = this.cjjlArr[this.cjjlArr.length-1]; // 赋值本轮抽奖
          }
        } else {
          this.cjjlArr = [];
        }
      });
    },
    // 奖池查询
    handler(type) {
      if(type==1){
        this.filPersons = this.smokeArr.filter(item => {
          return item.playercode.indexOf(this.jccxinput) != -1
        })
      }else{
        // 重置
        this.jccxinput = '';
        this.filPersons = [];
      }
    },
  },
  created() {
    this.listId = this.$route.query.yyqid; // 获取列表id
    this.yyqtype = this.$route.query.yyqtype; // 获取 店铺活动 or 联盟活动
    this.hdcjState = this.$route.query.hdcjState; // 获取选中行状态 7
    this.getcjjl(1); // 抽奖记录
    this.getchoujiang(); // 抽奖集合
  },
  mounted(){
    
  },
}
</script>
<style>
/* 抽奖背景 */
.hdcjbj{
  width: 100%;
  height: 100vh;
  background: url('../assets/img/hdcj.png') no-repeat;
  background-size: 100% 100%;
  margin: 0 auto;
  overflow: hidden;
}
/* 设置 */
.broadsidesz{
  width: 30vh;
  height: auto;
  background: #CE333A;
  /* margin-top: 200px; */
  padding-bottom: 20px;
  padding-top: 20px;
  color: #fff;
}
.broadsidesz>b{
  font-size: 20px;
  color: #EECC44;
}

/* 抽奖记录 & 奖池查询 */
.cjjlzk{
  width: 150px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: #EECC44;
  border-radius: 0px 25px 25px 0px;
  opacity: 1;
  font-size: 20px;
  font-weight: bold;
  color: #222222;
  cursor: pointer;
}
/* 奖池查询 */
.jccxbtn{
  position: absolute;
  right: 0;
  border-radius: 25px 0px 0px 25px;
}
.cjjlzk>i{
  font-weight: bold;
}

/* 抽奖记录 */
.broadsidecjjl{
  width: 30vh;
  height: auto;
  background: #CE333A;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  padding: 30px 0;
  color: #fff;
}
.broadsidecjjl.hidden {
  transform: translateX(-30vh);
}
.hiddenparts.hidden {
  transform: translateX(30vh);
}
.broadsidecjjl>b{
  font-size: 20px;
  color: #EECC44;
  margin-left: 30px;
}
.cjjlthree{
  margin: 20px 0 0 30px;
}
/* 收起箭头 */
.shouqiicon{
  width: 100%;
  height: 20px;
  margin-top: 10px;
  position: relative;
}
/* 收起icon */
.cjjlsq{
  width: 32px;
  height: 32px;
  line-height: 32px;
  background: #EECC44;
  border-radius: 50px;
  text-align: center;
  color: #222222;
  font-size: 16px;
  font-weight: bold;
  position: absolute;
  right: 30px;
  cursor: pointer;
}
.jccxsq{
  left: 30px;
}

.lotteryContainer{
  width: 100%;
  height: 100vh;
  position: relative;
}
.lotteryMain{
  width: 100%;
  height: 48vh;
  position: absolute;
  left: 0;
  top: 26%;
  /* transform: translate3d(-50%,0,0); */
  z-index: 2;
  overflow: hidden;
}
.lottery-tips{
  font-size: 3vh;
  font-weight: bold;
  color: #fff;
  text-align: center;
}
.lottery-item{
  height: 7.6vh;
  line-height: 7.6vh;
  margin-top: 1%;
  text-align: center;
  background-image: url(../assets/img/roll.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  position: relative;
}
.lottery-roll{
  display: flex;
}
.rollItem{
  width: 30%;
  /* font-size: 3.6vh; */
  font-size: 36px;
  font-weight: bold;
  color: #222222;
  display: flex;
  justify-content: center;
  align-items: center;
}
.rollItem:first-child{
  width: 15%;
}
.rollItem:last-child{
  width: 50%;
}
.rollItem>span{
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.rollItem>img{
  width: 5vh;
  height: 5vh;
  border-radius: 50%;
}
.lotterybtn{
  position: absolute;
  width: 66%;
  left: 50%;
  bottom: 13%;
  transform: translate3d(-50%, 0, 0);
  z-index: 2;
}
.btnfunc{
  padding: 0 15%;
  display: flex;
  justify-content: space-between;
}
.btnImg{
  width: 186px;
  height: 86px;
  border-radius: 30vh;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}
.btnImg>img{
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// eventlottery.vue?6858e464